import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { SignPage } from './pages/SignPage';
import { Portal } from './pages/Portal';
import { Terminos } from './pages/Terminos';
import { Privacidad } from './pages/Privacidad';
import { Reembolsos } from './pages/Reembolsos';
import { ReaderStateProvider } from './lib/readerState';
import { initMetaPixel, trackViewContent } from './lib/metaPixel';
import { LiveActivityNotifier } from './components/shared/LiveActivityNotifier';
import { MobileStickyCTA } from './components/shared/MobileStickyCTA';
// Tracks ViewContent on every route change (dedupes internally per path)
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackViewContent(location.pathname);
  }, [location.pathname]);
  return null;
}
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <BrowserRouter data-id="element-0">
      <ReaderStateProvider data-id="element-1">
        <RouteTracker data-id="element-2" />
        <div className="min-h-screen w-full bg-cosmic-black" data-id="element-3">
          <Navbar data-id="element-4" />
          <main className="pt-16" data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
              <Route path="/portal-de-usuario" element={<Portal data-id="element-10" />} data-id="element-9" />
              <Route path="/terminos" element={<Terminos data-id="element-12" />} data-id="element-11" />
              <Route path="/privacidad" element={<Privacidad data-id="element-14" />} data-id="element-13" />
              <Route path="/reembolsos" element={<Reembolsos data-id="element-16" />} data-id="element-15" />
              <Route path="/:signId" element={<SignPage data-id="element-18" />} data-id="element-17" />
            </Routes>
          </main>
          <Footer data-id="element-19" />
          <LiveActivityNotifier data-id="element-20" />
          <MobileStickyCTA data-id="element-21" />
        </div>
      </ReaderStateProvider>
    </BrowserRouter>;
}